import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Outlet, useNavigate, useParams } from "react-router-dom";

import { useGetOrganizerServiceInfoQuery } from "../../graphql/event.hooks";
import useGetUrlLocale from "../../hooks/useGetUrlLocale";
import { authService } from "../../services/authService";
import { redirectToLogin } from "../../utils/redirectToLogin";
import { languages } from "../menu";
import GlobalModals from "../modals/GlobalModals";
import Spinner from "../ui/spinner";

const Layout = () => {
  const { locale = "en" } = useParams();
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const urlLocale = useGetUrlLocale();
  const { data, loading, error } = useGetOrganizerServiceInfoQuery();

  useEffect(() => {
    if (languages.find((el) => el.value === locale)) {
      i18n.changeLanguage(locale);
    } else {
      navigate(`${urlLocale}/create-event`, { replace: true });
    }
  }, [locale, i18n, navigate, urlLocale]);

  useEffect(() => {
    if (error) {
      redirectToLogin();
    }
  }, [error]);

  if (data) {
    authService.setUser(data);
  }

  if (loading || !data) {
    return <Spinner wrapperClassName="mt-5 pt-5" />;
  }

  return (
    <>
      <Outlet />
      <GlobalModals />
    </>
  );
};

export default Layout;
